export const SectionTitle = ({ eyebrow, title, subtitle, dark = false, align = "left", eyebrowWhite = false }) => {
  const textAlignClass = align === "center" ? "text-center" : "text-left";
  const eyebrowColor = eyebrowWhite ? "#ffffff" : (dark ? "#fca5a5" : "var(--color-brand-red)");
  return (
    <header className={`${textAlignClass} mb-10`}>
      {eyebrow ? (
        <p
          className="text-xs font-bold uppercase tracking-[0.16em]"
          style={{ color: eyebrowColor }}
        >
          {eyebrow}
        </p>
      ) : null}
      <h2 className="mt-4 text-3xl font-black leading-tight sm:text-4xl lg:text-5xl">{title}</h2>
      {subtitle ? (
        <p className="mt-4 max-w-3xl text-sm leading-relaxed sm:text-base mx-auto">{subtitle}</p>
      ) : null}
    </header>
  );
};

